import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://hospytl.com/be/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add interceptors if needed (e.g., auth tokens)
// Request Interceptor to attach token
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => Promise.reject(error));

export default api;
